import MotifHalo from './MotifHalo';
import MotifHaloOrbit from './MotifHaloOrbit';
import MotifMark from './MotifMark';
import MotifOrbit from './MotifOrbit';
import MotifSteps from './MotifSteps';

export type MotifKind = 'halo' | 'orbit' | 'mark' | 'steps' | 'halo-orbit';

interface MotifProps {
  kind: MotifKind;
}

const Motif = ({ kind }: MotifProps) => {
  switch (kind) {
    case 'orbit':
      return <MotifOrbit />;
    case 'mark':
      return <MotifMark />;
    case 'steps':
      return <MotifSteps />;
    case 'halo-orbit':
      return <MotifHaloOrbit />;
    default:
      return <MotifHalo />;
  }
};

export default Motif;
